import React from "react";
import ScrollToTop from "../../utils/ScrollToTop";
import Footer from "../Footer";
import Navbar from "../Navbar";
import ScrollButton from "../ScrollToTop";

const Layout = ({ children }) => {
  return (
    <div>
      <ScrollToTop />
      <Navbar />
      <main>
        <section className="contentWrapper">{children}</section>
      </main>
      <Footer />
      <ScrollButton />
    </div>
  );
};

export default Layout;
